import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

const YAPI = false

export const getRecommendData = async (params: object) => {
  return await GET({
    url: YAPI
      ? 'http://yapi.bingex.com/mock/148/recommend/countDetail'
      : '/v3/recommend/countDetail',
    params,
    showError: false
  })
}
